 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"about":"about","home~word-net":"home~word-net","home":"home","info-ret~rec-sys~rules~word-net":"info-ret~rec-sys~rules~word-net","word-net":"word-net","info-ret~rec-sys":"info-ret~rec-sys","info-ret":"info-ret","rec-sys":"rec-sys","rules":"rules"}[chunkId]||chunkId) + "." + {"about":"9ea87f9b","home~word-net":"0eea14a4","home":"0ea21908","info-ret~rec-sys~rules~word-net":"733c7270","word-net":"7752ad76","info-ret~rec-sys":"8b26caff","info-ret":"ca25ae84","rec-sys":"eb87fe9b","rules":"2934eb48","chunk-2d0aa240":"81abcc05","chunk-2d0aadc3":"cf678516","chunk-2d0ac04b":"77475fa4","chunk-2d0ac23d":"8046a349","chunk-2d0ac3d0":"fddb0642","chunk-2d0ae9a9":"5371c17f","chunk-2d0aed39":"c6ad5092","chunk-2d0aed45":"6be63811","chunk-2d0afe3a":"9a08c38a","chunk-2d0b25b4":"e1d88668","chunk-2d0b993e":"2e29b286","chunk-2d0b9de7":"52427108","chunk-2d0bff10":"02fce169","chunk-2d0c268a":"58fc5c40","chunk-2d0c5759":"cb6cc63e","chunk-2d0cb763":"1b3ae766","chunk-2d0cbb21":"149e9e0a","chunk-2d0cbe65":"339c0237","chunk-2d0cc633":"916cab2b","chunk-2d0d01f7":"d8222e50","chunk-2d0d099c":"ade87ede","chunk-2d0d0f3a":"82a83a84","chunk-2d0d3e67":"f9ee5da9","chunk-2d0d5b96":"6bf7f620","chunk-2d0d5ff2":"78142f8c","chunk-2d0d70a5":"f09fd25d","chunk-2d0d72e5":"7ad18c42","chunk-2d0d7d58":"ff0e8eb0","chunk-2d0d83c7":"0a5aeb7b","chunk-2d0dae64":"85b7b128","chunk-2d0db83a":"ab2da135","chunk-2d0dda1f":"cd3659f6","chunk-2d0ddb86":"03b033e6","chunk-2d0df3e7":"473b268b","chunk-2d0e144c":"fd7b7c97","chunk-2d0e44c1":"d34ded71","chunk-2d0e4e7c":"5587af3c","chunk-2d0f0462":"1efe7c8e","chunk-2d0f0483":"a6a0c9e9","chunk-2d0f0b78":"391ab3d4","chunk-2d2080bd":"fa1ab1f5","chunk-2d208ca8":"1344eb45","chunk-2d2093db":"278297d1","chunk-2d212f0a":"90eb0db5","chunk-2d21b123":"f546e2fc","chunk-2d222184":"10ec0ae1","chunk-2d2244e4":"f1cc6be4","chunk-2d2261c5":"ad9ddd82","chunk-2d226339":"8a990e63","chunk-2d226388":"058d32db","chunk-2d22895e":"4858570b","chunk-2d229968":"3f699272","chunk-2d22cc58":"17a2bc31","chunk-2d22d99a":"2ad48fe6","chunk-2d22fcd9":"097a20bb","chunk-2d230f7b":"a7f23557","chunk-2d238437":"f4505d3d"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"about":1,"home":1,"word-net":1,"info-ret~rec-sys":1,"info-ret":1,"rec-sys":1,"rules":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"about":"about","home~word-net":"home~word-net","home":"home","info-ret~rec-sys~rules~word-net":"info-ret~rec-sys~rules~word-net","word-net":"word-net","info-ret~rec-sys":"info-ret~rec-sys","info-ret":"info-ret","rec-sys":"rec-sys","rules":"rules"}[chunkId]||chunkId) + "." + {"about":"9aae6bc0","home~word-net":"31d6cfe0","home":"04a4277b","info-ret~rec-sys~rules~word-net":"31d6cfe0","word-net":"0792d890","info-ret~rec-sys":"5dcb2634","info-ret":"7e6c4f04","rec-sys":"25db3b52","rules":"ca03e693","chunk-2d0aa240":"31d6cfe0","chunk-2d0aadc3":"31d6cfe0","chunk-2d0ac04b":"31d6cfe0","chunk-2d0ac23d":"31d6cfe0","chunk-2d0ac3d0":"31d6cfe0","chunk-2d0ae9a9":"31d6cfe0","chunk-2d0aed39":"31d6cfe0","chunk-2d0aed45":"31d6cfe0","chunk-2d0afe3a":"31d6cfe0","chunk-2d0b25b4":"31d6cfe0","chunk-2d0b993e":"31d6cfe0","chunk-2d0b9de7":"31d6cfe0","chunk-2d0bff10":"31d6cfe0","chunk-2d0c268a":"31d6cfe0","chunk-2d0c5759":"31d6cfe0","chunk-2d0cb763":"31d6cfe0","chunk-2d0cbb21":"31d6cfe0","chunk-2d0cbe65":"31d6cfe0","chunk-2d0cc633":"31d6cfe0","chunk-2d0d01f7":"31d6cfe0","chunk-2d0d099c":"31d6cfe0","chunk-2d0d0f3a":"31d6cfe0","chunk-2d0d3e67":"31d6cfe0","chunk-2d0d5b96":"31d6cfe0","chunk-2d0d5ff2":"31d6cfe0","chunk-2d0d70a5":"31d6cfe0","chunk-2d0d72e5":"31d6cfe0","chunk-2d0d7d58":"31d6cfe0","chunk-2d0d83c7":"31d6cfe0","chunk-2d0dae64":"31d6cfe0","chunk-2d0db83a":"31d6cfe0","chunk-2d0dda1f":"31d6cfe0","chunk-2d0ddb86":"31d6cfe0","chunk-2d0df3e7":"31d6cfe0","chunk-2d0e144c":"31d6cfe0","chunk-2d0e44c1":"31d6cfe0","chunk-2d0e4e7c":"31d6cfe0","chunk-2d0f0462":"31d6cfe0","chunk-2d0f0483":"31d6cfe0","chunk-2d0f0b78":"31d6cfe0","chunk-2d2080bd":"31d6cfe0","chunk-2d208ca8":"31d6cfe0","chunk-2d2093db":"31d6cfe0","chunk-2d212f0a":"31d6cfe0","chunk-2d21b123":"31d6cfe0","chunk-2d222184":"31d6cfe0","chunk-2d2244e4":"31d6cfe0","chunk-2d2261c5":"31d6cfe0","chunk-2d226339":"31d6cfe0","chunk-2d226388":"31d6cfe0","chunk-2d22895e":"31d6cfe0","chunk-2d229968":"31d6cfe0","chunk-2d22cc58":"31d6cfe0","chunk-2d22d99a":"31d6cfe0","chunk-2d22fcd9":"31d6cfe0","chunk-2d230f7b":"31d6cfe0","chunk-2d238437":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/idsai/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
